export const invertedMessages = {
  Cancel: 'CERTS_CANCEL',
  'View Consulted List': 'CERTS_DETAILS_PEND_CONSULT_BUTTON',
  'View To-Do List': 'CERTS_DETAILS_NOT_CERTIFIED_BUTTON',
  Complete: 'CERTS_COMPLETE',
  Next: 'CERTS_NEXT',
  Submit: 'SubmitLabel.ATTESTATIONS',
  'Certification succesfully submitted': 'REVIEW_CERTIFICATION_SUBMITTED',
  'Your certification {certificationName} has been submitted.':
    'REVIEW_CERTIFICTAION_NAME',
  Success: 'CERTS_SUCCESS',
};
